import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/Layout'
import callback from '@/components/callback'
import list from '@/components/menu/list'
import mine from '@/components/menu/mine'
import useractivity from '@/components/menu/user/activity'
import userdemand from '@/components/menu/user/demand'
import usersupply from '@/components/menu/user/supply'
import apply from '@/components/menu/apply'
import first from '@/components/menu/join/first'
import second from '@/components/menu/join/second-entry'
import third from '@/components/menu/join/third'
import contract from '@/components/menu/join/contract'
import wait from '@/components/menu/join/wait'
import success from '@/components/menu/join/success'
import reject from '@/components/menu/join/reject'
import add from '@/components/add'
import activity from '@/components/menu/activityLayout'
import activityList from '@/components/menu/activity/list'
import activityInfo from '@/components/menu/activity/info'
import blank from '@/components/menu/activity/blank'
import supplyDemandInfo from '@/components/menu/supplyDemandInfo'
import { normalizeMemberInfo, getApplyRoute } from '@/utils/memberStatus'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      component: Layout,
      redirect:'/supply-demand',
      children:[
        {path: 'supply-demand', name: 'supply-demand', component: list},
        {path: 'mine', name: 'mine', component: mine},
        {
          path: '/apply',
          component:apply,
          redirect:'/apply/first',
          children:[
            {path: 'first', name: 'first', component: first},
            {path: 'contract', name: 'contract', component: contract},
            {path: 'second', name: 'second', component: second},
            {path: 'third', name: 'third', component: third},
            {path: 'wait', name: 'wait', component: wait},
            {path: 'success', name: 'success', component: success},
            {path: 'reject', name: 'reject', component: reject},
          ]
        },
        {
          path: '/activity',
          component:activity,
          redirect:'/activity/activityList',
          children:[
            // {path: 'first', name: 'first', component: first},
            {path: 'activityList', name: 'activityList', component: activityList},
          ]
        }
      ]
    },
    {path: '/callback', name: 'callback', component: callback},
    {path: '/add', name: 'add', component: add},
    {path: '/activityInfo/:id', name: 'activityInfo', component: activityInfo},
    {path: '/blank/:id', name: 'blank', component: activityInfo},
    {path: '/supplyDemandInfo/:id', name: 'supplyDemandInfo', component: supplyDemandInfo},
    {path: '/useractivity', name: 'useractivity', component: useractivity},
    {path: '/userdemand', name: 'userdemand', component: userdemand},
    {path: '/usersupply', name: 'usersupply', component: usersupply},
  ]
})
// 路由守卫：检查登录态
router.beforeEach((to, from, next) => {
  // 白名单：不需要登录校验的页面
  
  const whiteRouteNames = [
    'callback',
    'supply-demand',
    'supplyDemandInfo',
    'activityList',
    'activityInfo'
  ]

  if (whiteRouteNames.includes(to.name)) {
    return next()
  }

  const token = sessionStorage.getItem('token')
  if (!token) {
    // 没登录 → 跳微信授权
    // const appid = 'wx3b41c430397d5362'
    const appid = 'wx547ed798a7e21729'
    const redirectUri = encodeURIComponent(location.origin + '/#/callback?'+from.path)
    const scope = 'snsapi_userinfo' // 静默
    const state = 'xxx' // 随机字符串防csrf
    const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`
    window.location.href = authUrl
    return
  }
  const userInfo = normalizeMemberInfo(JSON.parse(sessionStorage.getItem('userInfo') || '{}'))
  const applyTarget = getApplyRoute(JSON.parse(sessionStorage.getItem('userInfo') || '{}'))
  if ((to.path === '/apply' || to.path === '/apply/first') && applyTarget && to.path !== applyTarget) {
    return next(applyTarget)
  }
  const personalForbiddenPaths = ['/add', '/userdemand', '/usersupply']
  if (userInfo.memberType === 'PERSONAL'
      && personalForbiddenPaths.includes(to.path)) {
    return next('/activity')
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js